'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Image: ()=>Image
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_ImageVariants_cjs_namespaceObject = require("./ImageVariants.cjs");
const DEFAULT_IMAGE = 'https://s1.pclncdn.com/design-assets/brand-assets/default_image.jpeg';
const Image = ({ src = DEFAULT_IMAGE, alt, width, maxWidth, height, maxHeight, ratio, borderRadius, shadow, objectFit, objectPosition, isLoading, className, isSvg, ...props })=>{
    const classes = (0, external_ImageVariants_cjs_namespaceObject.image)({
        width,
        maxWidth,
        height,
        maxHeight,
        ratio,
        borderRadius,
        shadow,
        objectFit,
        objectPosition,
        isLoading,
        className,
        isSvg
    });
    const combinedClasses = ratio ? `${classes} aspect-${ratio}` : classes;
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("img", {
        src: src,
        alt: alt,
        className: combinedClasses,
        ...props,
        style: {
            aspectRatio: ratio
        },
        decoding: "async"
    });
};
exports.Image = __webpack_exports__.Image;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Image"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
